import type * as api from '@gitbook/api-client';
import { Block, Fragment } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_FILE, FRAGMENT_CAPTION } from '../types';

/**
 * Create a file block.
 */
export function createFileBlock(ref: api.ContentRefFile, caption = '') {
    return Block.createVoid({
        type: BLOCK_FILE,
        data: {
            ref,
        },
        fragments: [
            Fragment.create({
                fragment: FRAGMENT_CAPTION,
                nodes: [createParagraph(caption)],
            }),
        ],
    });
}
